import ContactBox from '~/themes/oknanebodvere/components/shop/ContactBox'
import DetectMobileMixin from '~/mixins/DetectMobileMixin'

export default {
  extends: ContactBox,
  mixins: [DetectMobileMixin],
  props: {
    alignContent: {
      type: String,
      default() {
        return this.$themeSettings.components.ContactBox.alignContent || 'center'
      },
    },
    variant: {
      type: String,
      default: 'default',
    },
    stickyEnable: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      isDesktopViewport: true,
    }
  },
  mounted() {
    this.updateViewportFlags()
    window.addEventListener('resize', this.updateViewportFlags, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportFlags)
  },
  methods: {
    updateViewportFlags() {
      this.isDesktopViewport = window.innerWidth >= 992
    },
  },
}
